import { render, staticRenderFns } from "./PendingContestTab.vue?vue&type=template&id=221f301c"
import script from "./PendingContestTab.vue?vue&type=script&lang=js"
export * from "./PendingContestTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports